export const USER_MENU = {
    firstLeveLMenu: [],
    secondLevelMenu: []
}